import React from "react";
import { useState } from "react";
import { Popover, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  ArrowRight,
  X,
  Search,
  Calendar,
  Check,
  Pause,
  Trash2,
  ChevronLeft,
  ChevronRight,
  ArrowUpRight,
  Eye,
  Edit2,
  Copy,
  Ban,
  Gift,
  Star,
  Coins,
  TrendingUp,
} from "lucide-react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  ComposedChart,
} from "recharts";
import { FiMoreVertical, FiChevronDown } from "react-icons/fi";
import "react-circular-progressbar/dist/styles.css";
import TotalVouchersIcon from "../../../assets/svg/path2.svg";
import ActiveIcon from "../../../assets/svg/Vector (1).svg";
import ScheduledIcon from "../../../assets/svg/calendar 1.svg";
import DraftIcon from "../../../assets/svg/draft 1.svg";
import UnderReviewIcon from "../../../assets/svg/clock (3) 1.svg";
import PausedIcon from "../../../assets/svg/pause-circle-svgrepo-com 1.svg";
import ExpiredIcon from "../../../assets/svg/support 1.svg";
import DisabledIcon from "../../../assets/svg/Cancel.svg";
import batteryIcon from "../../../assets/images/battery.png";
import oilIcon from "../../../assets/svg/Group 162552.svg";
import discount from "../../../assets/svg/ssss.svg";
import winBackIcon from "../../../assets/images/car-care.png";
import OsamaAvatar from "../../../assets/images/alert2 1.png";
import AhmedAvatar from "../../../assets/images/alert2 1 (1).png";
import redeemed from "../../../assets/svg/path2 (1).svg";
import spent from "../../../assets/svg/Vector (5).svg";
import cost from "../../../assets/svg/Vector (6).svg";
import rate from "../../../assets/svg/trend 1 (2).svg";
import './LoyaltyRewards.css'
import { useNavigate } from "react-router";

export default function LoyaltyRewards() {

  const navigate = useNavigate();
  const [selectedReward, setSelectedReward] = useState(null);
  const [showRewardModal, setShowRewardModal] = useState(false);
  // date input
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState(dayjs("2025-05-01"));
    const [endDate, setEndDate] = useState(dayjs("2025-05-31"));
    const [openMenuId, setOpenMenuId] = useState(null);

  const isDatePickerOpen = Boolean(dateAnchorEl);

  const handleDateClick = (e) => setDateAnchorEl(e.currentTarget);
  const handleDateClose = () => setDateAnchorEl(null);

  const dateRangeLabel = `${startDate.format("MMM DD, YYYY")} - ${endDate.format(
    "MMM DD, YYYY",
  )}`;

  // stats
  const stats = [
    {
      title: "Total Rewards",
      value: "128",
      icon: TotalVouchersIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "",
      trendType: "",
      subtitle: "All time",
    },
    {
      title: "Active",
      value: "76",
      icon: ActiveIcon,
      bg: "#3FBEAC",
      iconColor: "#14B8A6",
      trend: "+8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Scheduled",
      value: "12",
      icon: ScheduledIcon,
      bg: "#7E1BAD",
      iconColor: "#A855F7",
      trend: "+14%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Draft",
      value: "34",
      icon: DraftIcon,
      bg: "#8CB369",
      iconColor: "#65A30D",
      trend: null,
      trendType: "neutral",
      subtitle: "In progress",
    },
    {
      title: "Under Review",
      value: "18",
      icon: UnderReviewIcon,
      bg: "#FEB91E",
      iconColor: "#F59E0B",
      trend: null,
      trendType: "neutral",
      subtitle: "In review",
    },
    {
      title: "Paused",
      value: "6",
      icon: PausedIcon,
      bg: "#FC6C4F",
      iconColor: "#F43F5E",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Expired",
      value: "14",
      icon: ExpiredIcon,
      bg: "#696969",
      iconColor: "#FFFFFF",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Disabled",
      value: "8",
      icon: DisabledIcon,
      bg: "#A80101",
      iconColor: "#FFFFFF",
      trend: "+1%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
  ];

  // table
  const voucherTabs = [
    { key: "all", label: "All Rewards", count: 256 },
    { key: "active", label: "Active", count: 148 },
    { key: "scheduled", label: "Scheduled", count: 28 },
    { key: "draft", label: "Draft", count: 34 },
    { key: "underReview", label: "Under Review", count: 18 },
    { key: "paused", label: "Paused", count: 6 },
    { key: "expired", label: "Expired", count: 46 },
    { key: "disabled", label: "Disabled", count: 12 },
  ];

  const statusStyles = {
    Active: { bg: "#E6F7F4", color: "#14B8A6" },
    Scheduled: { bg: "#F3E8FF", color: "#A855F7" },
    Draft: { bg: "#EFFCE9", color: "#65A30D" },
  };

const rewardsData = [
  {
    id: "RW-001",
    name: "Free Oil Change",
    category: "Free Services",
    pointsRequired: 5000,
    estimatedCost: "120 EGP",
    redemptions: 3250,
    validity: "Mar 10 - May 31, 2025",
    status: "Active",
    lastUpdate: "2h ago",
    updatedBy: "Mona Ali",
  },
  {
    id: "RW-002",
    name: "10% OFF Discount",
    category: "Discount Coupons",
    pointsRequired: 2000,
    estimatedCost: "50 EGP",
    redemptions: 2870,
    validity: "Mar 10 - May 31, 2025",
    status: "Active",
    lastUpdate: "2h ago",
    updatedBy: "Mona Ali",
  },
  {
    id: "RW-003",
    name: "Free Car Wash",
    category: "Free Services",
    pointsRequired: 1500,
    estimatedCost: "30 EGP",
    redemptions: 2120,
    validity: "Mar 10 - May 31, 2025",
    status: "Active",
    lastUpdate: "2h ago",
    updatedBy: "Mona Ali",
  },
  {
    id: "RW-004",
    name: "Engine Check Free",
    category: "Free Services",
    pointsRequired: 3000,
    estimatedCost: "80 EGP",
    redemptions: 1980,
    validity: "Mar 10 - May 31, 2025",
    status: "Scheduled",
    lastUpdate: "2h ago",
    updatedBy: "Mona Ali",
  },
  {
    id: "RW-005",
    name: "20% OFF Discount",
    category: "Discount Coupons",
    pointsRequired: 3500,
    estimatedCost: "90 EGP",
    redemptions: 1450,
    validity: "Mar 10 - May 31, 2025",
    status: "Disabled",
    lastUpdate: "2h ago",
    updatedBy: "Mona Ali",
  },
];

  const [activeVoucherTab, setActiveVoucherTab] = useState("all");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [voucherPage, setVoucherPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const totalVouchersCount = 256;

const filteredRewards =
  activeVoucherTab === "all"
    ? rewardsData
    : rewardsData.filter(
        (r) => r.status.toLowerCase() === activeVoucherTab.toLowerCase(),
      );

  const totalPages = Math.max(1, Math.ceil(totalVouchersCount / perPage));

  const startIndex = (voucherPage - 1) * perPage;

  const currentPageData = filteredRewards.slice(
    startIndex,
    startIndex + perPage,
  );

  const allSelected =
    currentPageData.length > 0 &&
    currentPageData.every((v) => selectedRows.has(v.id));

  const toggleRow = (id) => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (allSelected) {
        currentPageData.forEach((v) => next.delete(v.id));
      } else {
        currentPageData.forEach((v) => next.add(v.id));
      }
      return next;
    });
  };

  const getPageNumbers = (current, total) => {
    const pages = [];
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    pages.push(1, 2, 3, "...", total);
    return pages;
  };

  const pageNumbers = getPageNumbers(voucherPage, totalPages);
  const activeTabLabel =
    voucherTabs.find((t) => t.key === activeVoucherTab)?.label ||
    "All Vouchers";

  const usageTrendData = [
    { name: "Apr 22", redemption: 3400 },
    { name: "Apr 25", redemption: 5800 },
    { name: "Apr 29", redemption: 11200 },
    { name: "May 02", redemption: 6800 },
    { name: "May 06", redemption: 4600 },
    { name: "May 09", redemption: 5200 },
    { name: "May 11", redemption: 4300 },
    { name: "May 13", redemption: 6000 },
    { name: "May 16", redemption: 3000 },
    { name: "May 18", redemption: 3600 },
    { name: "May 20", redemption: 2500 },
  ];

  // Voucher Health (donut)
  const voucherHealthData = [
    { label: "Active", count: 148, pct: 57.8, color: "#3FBEAC" },
    { label: "Scheduled", count: 34, pct: 10.9, color: "#7E1BAD" },
    { label: "Draft", count: 41, pct: 13.3, color: "#8CB369" },
    { label: "Under Review", count: 22, pct: 7.0, color: "#FEB91E" },
    { label: "Paused", count: 7, pct: 2.3, color: "#FC6C4F" },
    { label: "Expired", count: 19, pct: 6.2, color: "#696969" },
    { label: "Disabled", count: 15, pct: 4.7, color: "#A80101" },
  ];

  const voucherHealthTotal = 312;

  // Build conic-gradient stops from the donut data
  const buildConicGradient = (segments) => {
    let acc = 0;
    const stops = segments.map((s) => {
      const start = acc;
      acc += s.pct;
      return `${s.color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  // Top User Segements
  const topUserSegements = [
    { num: "1", label: "New Customers", pct: 85 },
    { num: "2", label: "VIP Customers", pct: 75 },
    { num: "3", label: "Battery Discount", pct: 55 },
    { num: "4", label: "Infrequent Users", pct: 40 },
  ];

  // Recent Activity
  const recentActivity = [
    {
      name: "Osama Ali",
      avatar: OsamaAvatar,
      action: "created reward ",
      target: "Free Oil Discount",
      time: "20m ago",
    },
    {
      name: "Ahmed Hassan",
      avatar: AhmedAvatar,
      action: "updated",
      target: "10% OFF Discount",
      time: "1h ago",
    },
    {
      name: "Battery Discount",
      avatar: batteryIcon,
      action: "has been disabled",
      target: "",
      time: "1h ago",
    },
    {
      name: "Ahmed Hassan",
      avatar: AhmedAvatar,
      action: "updated",
      target: "10% OFF Discount",
      time: "1h ago",
    },
  ];

  // Near Expiry Vouchers
  const nearExpiryVouchers = [
    {
      image: batteryIcon,
      name: "Battery Discount",
      days: "Expires in 2 days",
    },
    {
      image: oilIcon,
      name: "Free Oil Change",
      days: "Expires in 5 days",
    },
    {
      image: discount,
      name: "10% OFF Discount",
      days: "Expires in 5 days",
    },
    {
      image: oilIcon,
      name: "Free Oil Change",
      days: "Expires in 5 days",
    },
    {
      image: winBackIcon,
      name: "Free Car Wash",
      days: "Expires in 10 days",
    },
  ];

  // Rewards Performance
  const rewardsPerformance = [
    {
      title: "Total Redeemed",
      value: "18540",
      icon: redeemed,
      trend: "+18%",
      color: "#F4F8F0",
    },
    {
      title: "Points Spent",
      value: "8,540,000 pts",
      icon: spent,
      trend: "+18%",
      color: "#FFFAEA",
    },
    {
      title: "Estimated Cost",
      value: "420,000 EGP",
      icon: cost,
      trend: "+18%",
      color: "#ECF9F7",
    },
    {
      title: "Redemption Rate",
      value: "68%",
      icon: rate,
      trend: "+18%",
      color: "#F6E9FC",
    },
  ];

  return (
    <div className="voucher-page-wrapper">
      <div className="voucher-overview">
        {/* STATS */}
        <div className="vouchers-stats-grid">
          {stats.map((item, i) => (
            <div className="vouchers-stat-card" key={i}>
              <div className="vouchers-stat-top">
                <div
                  className="vouchers-stat-icon"
                  style={{ backgroundColor: item.bg }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="vouchers-stat-icon-img"
                  />
                </div>
                <span className="vouchers-stat-title">{item.title}</span>
              </div>

              <div className="vouchers-stat-value">{item.value}</div>

              <div className="vouchers-stat-bottom">
                {item.trend ? (
                  <>
                    <span
                      className={`vouchers-trend vouchers-trend-${item.trendType}`}
                    >
                      {item.trend}
                    </span>
                    <span className="vouchers-trend-text">{item.subtitle}</span>
                  </>
                ) : (
                  <span className="vouchers-trend-text">{item.subtitle}</span>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* INSIGHTS SECTION */}
        <div className="voucher-insights-section">
          {/* LEFT COLUMN */}
          <div className="voucher-insights-left">
            {/* Usage Trend */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">
                  Usage Trend{" "}
                  <span className="vi-card-title-sub">(Last 30 Days)</span>{" "}
                </h4>
                <button className="vi-period-select">
                  Last 30 Days <FiChevronDown size={14} />
                </button>
              </div>
              <div className="usage-trend-chart">
                <ResponsiveContainer width="100%" height={310}>
                  <ComposedChart
                    data={usageTrendData}
                    margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
                  >
                    <CartesianGrid
                      horizontal={true}
                      vertical={false}
                      strokeDasharray="4 4"
                      stroke="#E5E7EB"
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 12, fill: "#9CA3AF" }}
                      interval="preserveStartEnd"
                      ticks={["Apr 22", "Apr 29", "May 06", "May 13", "May 20"]}
                      padding={{ left: 10, right: 10 }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 12, fill: "#9CA3AF" }}
                      tickFormatter={(v) => (v === 0 ? "0" : `${v / 1000}k`)}
                      domain={[0, 12000]}
                      ticks={[0, 2000, 4000, 6000, 8000, 10000, 12000]}
                    />
                    <Tooltip />
                    <defs>
                      <linearGradient
                        id="usageTrendGradient"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="0%"
                          stopColor="#3FBEAC"
                          stopOpacity={0.25}
                        />
                        <stop
                          offset="100%"
                          stopColor="#3FBEAC"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                    <Area
                      type="natural"
                      dataKey="redemption"
                      stroke="#3FBEAC"
                      strokeWidth={3}
                      fill="url(#usageTrendGradient)"
                      dot={false}
                      activeDot={{
                        r: 4,
                        fill: "#3FBEAC",
                        stroke: "#fff",
                        strokeWidth: 2,
                      }}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </div>
            {/* Rewards by Category + Top Redeemed Rewards */}
            <div className="vi-two-col-row">
              {/* Rewards by Category */}
              <div className="vi-card vi-half-card">
                <h4 className="vi-card-title">Rewards by Category</h4>
                <div className="voucher-health-body">
                  <div className="donut-wrapper">
                    <div
                      className="donut-ring"
                      style={{
                        background: buildConicGradient(voucherHealthData),
                      }}
                    >
                      <div className="donut-hole">
                        <span className="donut-total">
                          {voucherHealthTotal}
                        </span>
                        <span className="donut-total-label">Total</span>
                      </div>
                    </div>
                  </div>
                  <div className="donut-legend">
                    {voucherHealthData.map((s, i) => (
                      <div className="donut-legend-row" key={i}>
                        <span
                          className="donut-legend-dot"
                          style={{ backgroundColor: s.color }}
                        />
                        <span className="donut-legend-label">
                          {s.label} ({s.count})
                        </span>
                        <span className="donut-legend-pct">{s.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Top Redeemed Rewards */}
              <div className="vi-card vi-half-card">
                <h4 className="vi-card-title">Top Redeemed Rewards</h4>
                <div className="dist-list">
                  {topUserSegements.map((c, i) => (
                    <div className="dist-row" key={i}>
                      <div className="dist-left">
                        <span className="seg-dist-num-circle">{c.num}</span>
                        <span className="dist-label">{c.label}</span>
                      </div>
                      <div className="dist-bar-bg">
                        <div
                          className="seg-dist-bar-fill"
                          style={{ width: `${c.pct}%` }}
                        />
                      </div>
                      <span className="dist-pct">{c.pct.toFixed(1)}%</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT COLUMN (SIDEBAR) */}
           <div className="voucher-insights-right">
           {/* Expiring Soon */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Expiring Soon</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list">
                {nearExpiryVouchers.map((v, i) => (
                  <div className="sidebar-row" key={i}>
                    <div className="sidebar-left">
                      <div className="sidebar-icon-circle sidebar-icon-outline">
                        <img
                          src={v.image}
                          alt={v.name}
                          className="sidebar-icon-image"
                        />
                      </div>
                      <span className="sidebar-name">{v.name}</span>
                    </div>
                    <span className="sidebar-days">{v.days}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Recent Activity */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Recent Activity</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list activity-list">
                {recentActivity.map((a, i) => (
                  <div className="sidebar-row activity-row" key={i}>
                    <div className="sidebar-left">
                      <img
                        src={a.avatar}
                        alt={a.name}
                        className="activity-avatar"
                      />
                      <span className="activity-text">
                        <b>{a.name}</b> {a.action} <b>{a.target}</b>
                      </span>
                    </div>
                    <span className="sidebar-time">{a.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Bundles Performance */}
        <div className="vi-card mt-4">
          <h4 className="vi-card-title">Rewards Performance </h4>
          <div className="rewards-impact-grid">
            {rewardsPerformance.map((item, i) => (
              <div className="reward-bi-item" key={i}>
                <div
                  className="rewards-stat-icon"
                  style={{ backgroundColor: item.color }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="rewards-stat-icon-img"
                  />
                </div>
                <div className="bi-content">
                  <span className="bi-label">{item.title}</span>
                  <div className="bi-value">{item.value}</div>
                  <div className="bi-trend">
                    <span className="bi-trend-arrow">
                      <ArrowUpRight size={10} />
                    </span>
                    <span className="bi-trend-pct">{item.trend}</span>
                    <span className="bi-trend-text">vs last 30 days</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Filters */}
        <div className="vouchers-filters-bar">
          <div className="vouchers-search-box">
            <Search size={16} color="#9CA3AF" />
            <input
              type="text"
              className="vouchers-search-input"
              placeholder="Search voucher by name, code, id.."
            />
          </div>

          <div className="vouchers-filters-right">
            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Category</label>
              <select className="vouchers-filter-select" defaultValue="all">
                <option value="all">All Categories</option>
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>

            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Points Required</label>
              <select className="vouchers-filter-select" defaultValue="all">
                <option value="all">All Points</option>
                <option value="internal">Internal</option>
                <option value="partner">Partner</option>
              </select>
            </div>

            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Date Range</label>
              <button
                type="button"
                className="vouchers-date-range-btn"
                onClick={handleDateClick}
              >
                <span>{dateRangeLabel}</span>
                <Calendar size={16} color="#6B7280" />
              </button>

              <Popover
                open={isDatePickerOpen}
                anchorEl={dateAnchorEl}
                onClose={handleDateClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box sx={{ p: 2, display: "flex", gap: 2 }}>
                    <DatePicker
                      label="From"
                      value={startDate}
                      onChange={(newValue) =>
                        newValue && setStartDate(newValue)
                      }
                      maxDate={endDate}
                      slotProps={{ textField: { size: "small" } }}
                    />
                    <DatePicker
                      label="To"
                      value={endDate}
                      onChange={(newValue) => newValue && setEndDate(newValue)}
                      minDate={startDate}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </Box>
                </LocalizationProvider>
              </Popover>
            </div>
          </div>
        </div>
        {/* Table */}
        <div className="vouchers-table-section">
          <div className="vouchers-tabs-bar">
            {voucherTabs.map((tab) => (
              <button
                key={tab.key}
                className={`vouchers-tab ${
                  activeVoucherTab === tab.key ? "active" : ""
                }`}
                onClick={() => {
                  setActiveVoucherTab(tab.key);
                  setVoucherPage(1);
                  setSelectedRows(new Set());
                }}
              >
                {tab.label}{" "}
                <span className="vouchers-tab-count">{tab.count}</span>
              </button>
            ))}
          </div>
          <div className="vouchers-table-card">
            <div className="vouchers-table-header">
              <h3>{activeTabLabel}</h3>
              {selectedRows.size > 0 && (
                <div className="vouchers-bulk-actions">
                  <span className="vouchers-selected-count">
                    {selectedRows.size} selected
                  </span>
                  <span className="vouchers-bulk-divider">|</span>
                  <span className="vouchers-bulk-label">Bulk actions:</span>
                  <button className="vouchers-bulk-btn vouchers-bulk-activate">
                    <Check size={14} /> Activate
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-pause">
                    <Pause size={14} /> Pause
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-delete">
                    <Trash2 size={14} /> Delete
                  </button>
                  <button
                    className="vouchers-clear-selection"
                    onClick={() => setSelectedRows(new Set())}
                  >
                    <X size={14} /> Clear Selection
                  </button>
                </div>
              )}
            </div>
            <div className="vouchers-table-wrapper">
              <table className="vouchers-data-table">
                <thead>
                  <tr>
                    <th className="vouchers-checkbox-cell">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>ID</th>
                    <th>Reward Name</th>
                    <th>Category</th>
                    <th>Points required</th>
                    <th>Estimated Cost</th>
                    <th>Redemptions</th>
                    <th>Status</th>
                    <th>Validity</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPageData.map((r) => {
                    const style = statusStyles[r.status] || {
                      bg: "#F3F4F6",
                      color: "#6B7280",
                    };
                    return (
                      <tr key={r.id}>
                        <td className="vouchers-checkbox-cell">
                          <input
                            type="checkbox"
                            checked={selectedRows.has(r.id)}
                            onChange={() => toggleRow(r.id)}
                          />
                        </td>
                        <td className="vouchers-id-cell">{r.id}</td>
                        <td className="vouchers-name-cell">{r.name}</td>
                        <td>
                          <span className="vouchers-category-badge">
                            {r.category}
                          </span>
                        </td>
                        <td>{r.pointsRequired.toLocaleString()} pts</td>
                        <td>{r.estimatedCost}</td>
                        <td>{r.redemptions.toLocaleString()}</td>
                        <td>
                          <span
                            className="vouchers-status-badge"
                            style={{
                              backgroundColor: style.bg,
                              color: style.color,
                            }}
                          >
                            <span
                              className="vouchers-status-dot"
                              style={{ backgroundColor: style.color }}
                            />
                            {r.status}
                          </span>
                        </td>
                        <td>{r.validity}</td>
                        <td className="vouchers-lastupdate-cell">
                          <div>{r.lastUpdate}</div>
                          <div className="vouchers-lastupdate-user">
                            {r.updatedBy}
                          </div>
                        </td>
                        <td className="vouchers-action-cell">
                          <FiMoreVertical
                            onClick={() =>
                              setOpenMenuId(openMenuId === r.id ? null : r.id)
                            }
                            size={16}
                            style={{ cursor: "pointer" }}
                          />
                          {openMenuId === r.id && (
                            <div className="vouchers-action-menu">
                              <button
                                className="vouchers-action-item"
                                onClick={() => {
                                  setSelectedReward(r);
                                  setShowRewardModal(true);
                                  setOpenMenuId(null);
                                }}
                              >
                                <Eye size={14} /> View Details
                              </button>
                              <button
                                className="vouchers-action-item"
                                onClick={() => setOpenMenuId(null)}
                              >
                                <Edit2 size={14} /> Edit
                              </button>
                              <button
                                className="vouchers-action-item vouchers-action-warning"
                                onClick={() => setOpenMenuId(null)}
                              >
                                <Pause size={14} /> Pause
                              </button>
                              <button
                                className="vouchers-action-item"
                                onClick={() => setOpenMenuId(null)}
                              >
                                <Copy size={14} /> Duplicate
                              </button>
                              <button
                                className="vouchers-action-item vouchers-action-danger"
                                onClick={() => setOpenMenuId(null)}
                              >
                                <Ban size={14} /> Disable
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="vouchers-table-footer">
              <span className="vouchers-showing-text">
                Showing {startIndex + 1} of{" "}
                {Math.min(startIndex + perPage, totalVouchersCount)} of{" "}
                {totalVouchersCount} rewards
              </span>
              <div className="vouchers-footer-right">
                <select
                  className="vouchers-perpage-select"
                  value={perPage}
                  onChange={(e) => {
                    setPerPage(Number(e.target.value));
                    setVoucherPage(1);
                  }}
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                </select>
                <div className="vouchers-pagination">
                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === 1}
                    onClick={() => setVoucherPage((p) => Math.max(1, p - 1))}
                  >
                    <ChevronLeft size={16} />
                  </button>

                  {pageNumbers.map((n, i) =>
                    n === "..." ? (
                      <span key={i} className="vouchers-page-ellipsis">
                        ...
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`vouchers-page-btn ${
                          voucherPage === n ? "active" : ""
                        }`}
                        onClick={() => setVoucherPage(n)}
                      >
                        {n}
                      </button>
                    ),
                  )}

                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === totalPages}
                    onClick={() =>
                      setVoucherPage((p) => Math.min(totalPages, p + 1))
                    }
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showRewardModal && selectedReward && (
  <div className="reward-modal-overlay" onClick={() => setShowRewardModal(false)}>
    <div className="reward-modal" onClick={(e) => e.stopPropagation()}>
      <button className="reward-modal-close" onClick={() => setShowRewardModal(false)}>
        <X size={18} />
      </button>

      <h2 className="reward-modal-title">Rewards Details</h2>

      <div className="reward-modal-header">
        <div className="reward-modal-icon">
          <img
            src={selectedReward.icon || "/assets/reward-default.png"}
            alt=""
            onError={(e) => (e.target.style.display = "none")}
          />
        </div>
        <div className="reward-modal-header-info">
          <div className="reward-modal-name-row">
            <h3>{selectedReward.name}</h3>
            <span
              className={`reward-modal-status ${
                selectedReward.status?.toLowerCase() === "active" ? "active" : "inactive"
              }`}
            >
              • {selectedReward.status}
            </span>
          </div>
          <span className="reward-modal-id">Reward ID: {selectedReward.id}</span>
        </div>
      </div>

      <div className="reward-modal-tabs">
        <button className="active">Overview</button>
        <button>Redemption History</button>
        <button>Activity Log</button>
      </div>

      <div className="reward-modal-body">
        <h4>Rewards Information</h4>

        <div className="reward-modal-row">
          <span className="label">Category</span>
          <span className="badge-category">{selectedReward.category}</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Points Required</span>
          <span className="value">{selectedReward.pointsRequired?.toLocaleString()} pts</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Estimated Cost</span>
          <span className="value bold">{selectedReward.estimatedCost} EGP</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Validity Period</span>
          <span className="value">
            {selectedReward.validityStart} - {selectedReward.validityEnd}
          </span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Usage Limit</span>
          <span className="value">{selectedReward.usageLimit}</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Per Usage Limit</span>
          <span className="value">{selectedReward.perUsageLimit}</span>
        </div>
        <div className="reward-modal-row align-top">
          <span className="label">Description</span>
          <span className="value description">{selectedReward.description}</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Created By</span>
          <span className="value">{selectedReward.createdBy}</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Created At</span>
          <span className="value">{selectedReward.createdAt}</span>
        </div>
        <div className="reward-modal-row">
          <span className="label">Last Updated</span>
          <span className="value">{selectedReward.updatedAt}</span>
        </div>

        <h4>Points Summary</h4>
        <div className="reward-modal-summary-grid">
          <div>
            <span className="summary-label">Points Balance</span>
            <span className="summary-value">{selectedReward.pointsBalance?.toLocaleString()} pts</span>
          </div>
          <div>
            <span className="summary-label">Points Earned</span>
            <span className="summary-value">{selectedReward.pointsEarned?.toLocaleString()} pts</span>
          </div>
          <div>
            <span className="summary-label">Points Redeemed</span>
            <span className="summary-value">{selectedReward.pointsRedeemed?.toLocaleString()} pts</span>
          </div>
          <div>
            <span className="summary-label">Points Expired</span>
            <span className="summary-value expired">{selectedReward.pointsExpired?.toLocaleString()} pts</span>
          </div>
        </div>

        <h4>Performance Summary</h4>
        <div className="reward-modal-perf-grid">
          <div className="perf-item">
            <div className="perf-icon green">
              <Gift size={18} />
            </div>
            <div>
              <span className="perf-label">Total Redeemed</span>
              <span className="perf-value">{selectedReward.totalRedeemed?.toLocaleString()}</span>
            </div>
          </div>
          <div className="perf-item">
            <div className="perf-icon yellow">
              <Star size={18} />
            </div>
            <div>
              <span className="perf-label">Points Spent</span>
              <span className="perf-value">{selectedReward.pointsSpent?.toLocaleString()} pts</span>
            </div>
          </div>
          <div className="perf-item">
            <div className="perf-icon teal">
              <Coins size={18} />
            </div>
            <div>
              <span className="perf-label">Estimated Cost</span>
              <span className="perf-value">{selectedReward.estimatedCostTotal?.toLocaleString()} EGP</span>
            </div>
          </div>
          <div className="perf-item">
            <div className="perf-icon blue">
              <TrendingUp size={18} />
            </div>
            <div>
              <span className="perf-label">Redemption Rate</span>
              <span className="perf-value">{selectedReward.redemptionRate}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
        )}
    </div>
  );
}
